module.exports = __webpack_public_path__ + "img/map-gulfstreamG500.c9ecf2ee.jpg";